import { getCtData } from '../../../project';
import { getAddress } from './getAddress';

export const getBillingAddress = arrayAd => {
  const userData = getCtData('all.userData');
  const userCep = userData?.userCep.replace(/[^0-9]/g, '');

  const prefix = 'administrative_area_level_';
  const formatedZip = getAddress(arrayAd, 'postal_code').replace(',', '');
  const condZip = formatedZip === '' ? userCep : formatedZip;

  let form_billing_address: any = {};
  form_billing_address.line_1 = getAddress(arrayAd, 'route');
  form_billing_address.city = getAddress(arrayAd, prefix + 2);
  form_billing_address.state = getAddress(arrayAd, prefix + 1);
  form_billing_address.country = getAddress(arrayAd, 'country');
  form_billing_address.zip_code = condZip;

  return form_billing_address;
};
